// extracted by mini-css-extract-plugin
module.exports = {"container_bottom":"FNOLPolicySearchAndSelectComponent_AX_container_bottom__zcaCc","containerBottom":"FNOLPolicySearchAndSelectComponent_AX_container_bottom__zcaCc"};